import { render, staticRenderFns } from "./getCDRDetail.vue?vue&type=template&id=6e0bc313&"
import script from "./getCDRDetail.vue?vue&type=script&lang=js&"
export * from "./getCDRDetail.vue?vue&type=script&lang=js&"
import style0 from "./getCDRDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports